import {connect} from 'react-redux';
import StatisticsLoginTable from './StatisticsLoginTable';

const mapStateToProps = () => null;

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsLoginTable);
